/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.mcp.server.registry.rpc.McpConnectionRegistryRpc
 */

export const registerRpc = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpConnectionRegistryRpc',
  rpcName: 'register',
  auth: 'app',
  fingerprint: 'eif_VDrf7eChOCCvb2HicskRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const registerWithUnifiedAccountRpc = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpConnectionRegistryRpc',
  rpcName: 'registerWithUnifiedAccount',
  auth: 'app',
  fingerprint: 'DikgfhuioFyhOCCvb2HicskRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const fetchByIdRpc = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpConnectionRegistryRpc',
  rpcName: 'fetchById',
  auth: 'app',
  fingerprint: 'TyA0SEBahAahOCCvb2HicskRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const fetchByMcpServerIdRpc = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpConnectionRegistryRpc',
  rpcName: 'fetchByMcpServerId',
  auth: 'app',
  fingerprint: '9Mhq221VUjnT3S3TPqhfAMkRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteRpc = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpConnectionRegistryRpc',
  rpcName: 'delete',
  auth: 'app',
  fingerprint: 'nMaDJsz3WlO4SzFpk2_xw8kRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteSecretRpc = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpConnectionRegistryRpc',
  rpcName: 'deleteSecret',
  auth: 'app',
  fingerprint: 'nYAOSbWp6MWUsQ3BKKUq8skRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listConnectionsRpc = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpConnectionRegistryRpc',
  rpcName: 'listConnections',
  auth: 'app',
  fingerprint: '7iLmQiuuAv_T3S3TPqhfAMkRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};